import {createSelector} from "@ngrx/store";
import {selectFundContext} from "../../../fund/store/fund/fund.selectors";
import {selectSelectedAssetId} from "../../../asset/store/asset/asset.selectors";
import {selectSelectedDealId} from "../../../deal/store/deal/deal.selectors";
import {selectSelectedGeneralPartnerId} from "../../../fund/store/general-partner/general-partner.selectors";
import {AiChatContext} from "../../generated-sources/api/ai/model/ai-chat-context";

/**
 * Builds the AI chat context from all entity stores.
 * Note: currentRoute is NOT set here (no @ngrx/router-store) —
 * it is added by the component using Router.url at send time.
 */
export const selectAiChatContext = createSelector(
  selectFundContext,
  selectSelectedAssetId,
  selectSelectedDealId,
  selectSelectedGeneralPartnerId,
  (fundContext, assetId, dealId, generalPartnerId): AiChatContext => {
    return {
      fundId: fundContext.fundId ?? undefined,
      fundReportId: fundContext.fundReportId ?? undefined,
      fundValuationId: fundContext.fundValuationId ?? undefined,
      assetId: assetId ?? undefined,
      dealId: dealId ?? fundContext.dealId ?? undefined,
      generalPartnerId: generalPartnerId ?? undefined,
      dataset: "master",
    };
  },
);
